import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import { ReactComponent as TrailingIcon } from 'app/assets/img/iconTrailing.svg';
import InputNumberContainer from 'app/components/InputNumberContainer';
import useFetchData from 'app/hooks/useFetchData';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  getCommonMasterDataApi,
  getCommonAirportDataApi,
  getCommonFlightSegmentDataApi,
} from 'app/services/holidayApi';
import _ from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { objectToSearchParams, formatAirport } from 'utils/helper';
import { useSearchParams } from 'utils/hooks/useSearchParams';
import { selectTranslations } from '../App/slice/selectors';
import {
  COMBO_HOLIDAY_TYPES,
  ComboHolidayType,
  DataStage,
  DEFAULT_FILTER_SEARCH,
  ErrorDateHoliday,
  formatDate,
  IAirport,
  IFilterHolidaySearch,
  IItemAirport,
  IRegion,
  isHotelCombo,
  Stage,
  TypePoint,
} from '../BookingMask';
import {
  calculateHotelNights,
  clampAdultCount,
  clampChildCount,
  getAdultMinForCombo,
  getMaxAdultForCombo,
  getMaxChildForCombo,
  getHotelDisabledDate,
  isAdultDecrementDisabled,
  // isPassengerTotalExceeded,
  resolveRoomChangeState,
  syncHotelDatesWithFlight,
} from '../BookingMask/bookingMask.helpers';
// import { ValidationMessages } from '../PassengerInfo/constants/messages';
import { CustomRadioCatalog } from '../Catalog/components/helper';
import StyledDatePicker, {
  DatePickerWrapper,
} from '../NewAccount/components/StyledDatePicker';
import StyledSelect from '../NewAccount/components/StyledSelect';
import { FilterSearchWrapper } from './styled';
import AirportSelectPopover from '../BookingMask/AirportSelectPopover';
interface IFilterSearch {
  filterSearchRef?: any;
  onFetchDataInit?: any;
  isRefreshing: boolean;
  onAirportsChange?: (airports: {
    departure?: IAirport;
    destination?: IAirport;
  }) => void;
}
const hasError = error =>
  Object.values(error).some(v => v !== '' && v !== null && v !== undefined);
const FilterSearch: React.FC<IFilterSearch> = props => {
  const { filterSearchRef, onFetchDataInit, isRefreshing, onAirportsChange } =
    props;
  const location = useLocation();
  const translations = useSelector(selectTranslations);
  const { getUrlParam } = useSearchParams();
  const { device, windowSize } = useWindowSize();
  const history = useHistory();
  const isMobile = device === 'mobile';
  const isTablet = device === 'tablet';
  const popupContainer = useRef<HTMLDivElement>(null);
  const popupDestinationContainer = useRef<HTMLDivElement>(null);
  const dataStage: DataStage[] = [
    {
      label: translations?.['b2b.txt.oneWay'],
      value: 'one-way',
    },
    {
      label: translations?.['b2b.txt.roundTrip'],
      value: 'round-trip',
    },
  ];
  const [filter, setFilter] = useState<IFilterHolidaySearch>(
    DEFAULT_FILTER_SEARCH,
  );
  const [dataRegions, setDataRegions] = useState<IRegion[]>([]);
  const [dataRegionsDestination, setDataRegionsDestination] = useState<
    IRegion[]
  >([]);
  const [dataAirports, setDataAirports] = useState<IItemAirport[]>([]);
  const [dataSearchAirports, setDataSearchAirports] = useState<IItemAirport[]>(
    [],
  );
  const [regionSelected, setRegionSelected] = useState<IRegion>();
  const [airportSelected, setAirportSelected] = useState<IAirport>();
  const [regionDestinationSelected, setRegionDestinationSelected] =
    useState<IRegion>();
  const [airportDestinationSelected, setAirportDestinationSelected] =
    useState<IAirport>();
  const [isOpenDeparturePoint, setIsOpenDeparturePoint] =
    useState<boolean>(false);
  const [isOpenDestination, setIsOpenDestination] = useState<boolean>(false);
  const [error, setError] = useState<ErrorDateHoliday>({});
  const [isExtend, setIsExtend] = useState(false);
  const [textInputDeparture, setTextInputDeparture] = useState<string>('');
  const [isOnChangeDeparture, setIsOnChangeDeparture] =
    useState<boolean>(false);
  const [textInputDestination, setTextInputDestination] = useState<string>('');
  const [isOnChangeDestination, setIsOnChangeDestination] =
    useState<boolean>(false);
  const [dataFlightSegment, setDataFlightSegment] = useState<any>([]);
  useEffect(() => {
    onFetchMasterData();
    onFetchAirport();
  }, []);
  const { onFetchData: onFetchMasterData, isLoading: isLoadingMasterData } =
    useFetchData({
      actionApi: getCommonMasterDataApi,
      IIFE: false,
      onSuccess: response => {
        setDataRegions(response.data.regions);
      },
    });
  const { onFetchData: onFetchAirport } = useFetchData({
    actionApi: getCommonAirportDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataAirports(response.data);
      setDataSearchAirports(response.data);
    },
  });
  const {
    onFetchData: onFetchFlightSegment,
    isLoading: isLoadingFlightSegment,
  } = useFetchData({
    actionApi: getCommonFlightSegmentDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataFlightSegment(response.data);
    },
  });
  useEffect(() => {
    const comboType =
      (getUrlParam('comboType') as ComboHolidayType) ||
      COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET;
    const room = Math.min(5, Math.max(1, Number(getUrlParam('room')) || 1));
    const adultRaw = Number(getUrlParam('adult')) || 1;

    setFilter(prev => {
      const filterSearch: IFilterHolidaySearch = {
        ...prev,
        comboType,
        stage: (getUrlParam('stage') as Stage) || 'round-trip',
        departure: getUrlParam('departure') || '',
        destination: getUrlParam('destination') || '',
        departureDate: getUrlParam('departureDate') || '',
        returnDate: getUrlParam('returnDate') || '',
        checkin: getUrlParam('checkin') || prev.checkin,
        checkout: getUrlParam('checkout') || prev.checkout,
        hotelNights: Number(getUrlParam('hotelNights')) || 0,
        room,
        adult: clampAdultCount(
          adultRaw,
          comboType,
          room,
          Number(getUrlParam('child')) || 0,
        ),
        child: Number(getUrlParam('child')) || 0,
        infant: Number(getUrlParam('infant')) || 0,
        minPrice: Number(getUrlParam('minPrice')) ?? 0,
        maxPrice:
          getUrlParam('maxPrice') === null ||
          getUrlParam('maxPrice') === undefined
            ? 20000000
            : Number(getUrlParam('maxPrice')) ?? 20000000,
        ratings: getUrlParam('ratings')?.split(',') || [],
        amenities: getUrlParam('amenities')?.split(',') || [],
      };
      filterSearchRef.current = filterSearch;
      Promise.resolve().then(() => onFetchDataInit?.(filterSearch));
      return filterSearch;
    });
  }, [location.search]);
  useEffect(() => {
    if (airportSelected) {
      const nameText = formatAirport(airportSelected);
      setTextInputDeparture(nameText);
      setIsOnChangeDeparture(false);
      onFetchFlightSegment({
        payloadData: { departureCode: airportSelected.code },
      });
    }
  }, [airportSelected]);
  useEffect(() => {
    if (airportDestinationSelected) {
      const nameText = formatAirport(airportDestinationSelected);
      setTextInputDestination(nameText);
      setIsOpenDestination(false);
    }
  }, [airportDestinationSelected]);

  useEffect(() => {
    onAirportsChange?.({
      departure: airportSelected,
      destination: airportDestinationSelected,
    });
  }, [airportSelected, airportDestinationSelected, onAirportsChange]);

  const findAirportAndRegion = (regions: IRegion[], airportCode: string) => {
    for (const region of regions) {
      const airport = region.airports?.find(a => a.code === airportCode);
      if (airport) {
        return {
          region,
          airport,
        };
      }
    }
    return null;
  };
  useEffect(() => {
    if ((filter.departure || filter.departureCode) && dataRegions?.length > 0) {
      const departureTemp = findAirportAndRegion(
        dataRegions,
        filter.departure || filter.departureCode,
      );
      if (departureTemp) {
        setRegionSelected(departureTemp.region);
        setAirportSelected(departureTemp.airport);
      }
    }
  }, [filter, dataRegions]);
  useEffect(() => {
    if (
      (filter.destination || filter.destinationCode) &&
      dataRegionsDestination?.length > 0
    ) {
      const destinationTemp = findAirportAndRegion(
        dataRegionsDestination,
        filter.destination || filter.destinationCode,
      );
      if (destinationTemp) {
        setRegionDestinationSelected(destinationTemp.region);
        setAirportDestinationSelected(destinationTemp.airport);
      } else {
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionDestinationSelected(dataRegionsDestination?.[0]);
      }
    }
  }, [filter, dataRegionsDestination]);
  const syncHotelDates = useCallback(
    (prev: IFilterHolidaySearch): IFilterHolidaySearch => {
      if (!isHotelCombo(prev.comboType)) return prev;
      return {
        ...prev,
        ...syncHotelDatesWithFlight({
          stage: prev.stage,
          departureDate: prev.departureDate,
          returnDate: prev.returnDate || '',
        }),
      };
    },
    [],
  );

  const onChangeFilterStage = (stage: any) => {
    if (stage === 'one-way') {
      setError(prev => ({
        ...prev,
        departureDate: '',
        returnDate: '',
        hotelDates: '',
      }));
    } else {
      setError(prev => ({
        ...prev,
        hotelDates: '',
      }));
      if (filter.departureDate && filter.returnDate) {
        const departure = moment(filter.departureDate);
        const returnDate = moment(filter.returnDate);
        if (departure.isValid() && returnDate.isValid()) {
          if (departure.isAfter(returnDate)) {
            setError(prev => ({
              ...prev,
              returnDate:
                translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
            }));
            setFilter(prev => ({ ...prev }));
          }
        }
      }
    }
    setFilter(prev => syncHotelDates({ ...prev, stage }));
  };
  const onClickRegion = (region: any, type: TypePoint) => {
    if (type === 'departure') {
      setRegionSelected(region);
    } else if (type === 'destination') {
      setRegionDestinationSelected(region);
    }
  };
  const onClickAirport = (airport: any, type: TypePoint) => {
    if (type === 'departure') {
      setAirportSelected(airport);
      setIsOpenDeparturePoint(false);
      setFilter(prev => {
        let filterTemp = {
          ...prev,
          departure: airport.code,
          departureCode: airport.code,
        };
        if (airport.code === airportDestinationSelected?.code) {
          setAirportDestinationSelected(undefined);
          setTextInputDestination('');
          setRegionDestinationSelected(dataRegions[0]);
          filterTemp = { ...filterTemp, destination: '', destinationCode: '' };
        }
        return filterTemp;
      });

      const departureTemp = findAirportAndRegion(dataRegions, airport.code);
      if (departureTemp) {
        setRegionSelected(departureTemp.region);
      }
    } else if (type === 'destination') {
      setAirportDestinationSelected(airport);
      setIsOpenDestination(false);
      setFilter({
        ...filter,
        destination: airport.code,
        destinationCode: airport.code,
      });
      const departureTemp = findAirportAndRegion(
        dataRegionsDestination,
        airport.code,
      );
      if (departureTemp) {
        setRegionDestinationSelected(departureTemp.region);
      }
    }
  };
  const handleOpenChangeDeparturePoint = newOpen => {
    setIsOpenDeparturePoint(newOpen);
    if (!newOpen) {
      if (
        _.isEmpty(airportSelected) ||
        isOnChangeDeparture ||
        !textInputDeparture
      ) {
        setTextInputDeparture('');
        setAirportSelected(undefined);
        setIsOnChangeDeparture(false);
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionSelected(dataRegions?.[0]);
        setFilter({
          ...filter,
          departure: '',
          departureCode: '',
          destination: '',
          destinationCode: '',
        });
      } else if (airportSelected) {
        const departureTemp = findAirportAndRegion(
          dataRegions,
          airportSelected.code,
        );
        if (departureTemp) {
          setRegionSelected(departureTemp.region);
        }
      }
    }
  };
  const handleOpenChangeDestination = newOpen => {
    setIsOpenDestination(newOpen);
    if (!newOpen) {
      if (_.isEmpty(airportDestinationSelected) || isOnChangeDestination) {
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionDestinationSelected(dataRegionsDestination?.[0]);
        setFilter({
          ...filter,
          destination: '',
          destinationCode: '',
        });
      } else if (airportDestinationSelected) {
        const departureTemp = findAirportAndRegion(
          dataRegionsDestination,
          airportDestinationSelected.code,
        );
        if (departureTemp) {
          setRegionDestinationSelected(departureTemp.region);
        }
      }
    }
  };
  const handleInputChange =
    (type: 'departure' | 'destination') => (event: any) => {
      if (type === 'departure') {
        setIsOpenDeparturePoint(true);
        if (event.target.value) {
          setTextInputDeparture(event.target.value);
          setIsOnChangeDeparture(true);
        } else {
          setIsOnChangeDeparture(false);
          setTextInputDeparture('');
        }
      } else if (type === 'destination') {
        setIsOpenDestination(true);
        if (event.target.value) {
          setTextInputDestination(event.target.value);
          setIsOnChangeDestination(true);
        } else {
          setIsOnChangeDestination(false);
          setTextInputDestination('');
        }
      }
    };
  const onSwapPoint = () => {
    if (filter.departure && filter.destination) {
      setFilter({
        ...filter,
        departure: filter.destination,
        destination: filter.departure,
        departureCode: filter.destinationCode,
        destinationCode: filter.departureCode,
      });
      const departureTemp = findAirportAndRegion(
        dataRegions,
        filter.destination,
      );
      if (departureTemp) {
        setRegionSelected(departureTemp.region);
        setAirportSelected(departureTemp.airport);
      }
    }
  };
  const onChangeDepartureDate = (date: moment.Moment | null) => {
    if (date) {
      const departureDate = date.format('YYYY-MM-DD');
      if (
        isHotelCombo(filter.comboType) &&
        filter.returnDate &&
        date.isSame(moment(filter.returnDate), 'day')
      ) {
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            departureDate,
            returnDate: moment(date).add(1, 'day').format('YYYY-MM-DD'),
          }),
        );
        setError(prev => ({
          ...prev,
          departureDate: '',
          returnDate: '',
          hotelDates: '',
        }));
        return;
      }
      if (
        filter.stage === 'round-trip' &&
        filter.returnDate &&
        date.isAfter(moment(filter.returnDate))
      ) {
        setError(prev => ({
          ...prev,
          returnDate: translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
          hotelDates: '',
        }));
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            departureDate: date.format('YYYY-MM-DD'),
          }),
        );
        return;
      }
      setFilter(prev =>
        syncHotelDates({
          ...prev,
          departureDate: date.format('YYYY-MM-DD'),
        }),
      );
      setError(prev => ({
        ...prev,
        departureDate: '',
        returnDate: '',
        hotelDates: '',
      }));
    } else {
      setFilter(prev => syncHotelDates({ ...prev, departureDate: '' }));
      setError(prev => ({ ...prev, departureDate: '', hotelDates: '' }));
    }
  };
  const onChangeReturnDate = (date: moment.Moment | null) => {
    if (date) {
      if (filter.departureDate && date.isBefore(moment(filter.departureDate))) {
        setError(prev => ({
          ...prev,
          returnDate: translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
        }));
        setFilter(prev => ({ ...prev, returnDate: '' }));
        return;
      }
      if (
        filter.departureDate &&
        date.isSameOrAfter(moment(filter.departureDate))
      ) {
        setError(prev => ({
          ...prev,
          departureDate: '',
          returnDate: '',
          hotelDates: '',
        }));
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            returnDate: date.format('YYYY-MM-DD'),
          }),
        );
        return;
      }
      setFilter(prev =>
        syncHotelDates({
          ...prev,
          returnDate: date.format('YYYY-MM-DD'),
        }),
      );
    } else {
      setFilter(prev => syncHotelDates({ ...prev, returnDate: '' }));
    }
  };

  const hotelDisabledDate = (current: moment.Moment) =>
    getHotelDisabledDate({
      stage: filter.stage,
      departureDate: filter.departureDate,
      returnDate: filter.returnDate,
    })(current);

  const onChangeCheckInDate = (date: moment.Moment | null) => {
    if (!date) {
      setFilter(prev => ({ ...prev, checkin: '', checkout: '' }));
      setError(prev => ({ ...prev, hotelDates: '' }));
      return;
    }
    const checkin = date.format('YYYY-MM-DD');
    setFilter(prev => {
      const shouldClearCheckOut =
        prev.checkout && moment(prev.checkout).isSameOrBefore(date, 'day');
      return {
        ...prev,
        checkin,
        checkout: shouldClearCheckOut ? '' : prev.checkout,
      };
    });
    if (
      filter.checkout &&
      moment(filter.checkout).isSameOrBefore(date, 'day')
    ) {
      setError(prev => ({ ...prev, hotelDates: '' }));
    }
  };

  const onChangeCheckOutDate = (date: moment.Moment | null) => {
    if (!date) {
      setFilter(prev => ({ ...prev, checkout: '' }));
      setError(prev => ({ ...prev, hotelDates: '' }));
      return;
    }
    const checkout = date.format('YYYY-MM-DD');
    if (
      !filter.checkin ||
      moment(checkout).isSameOrBefore(moment(filter.checkin), 'day')
    ) {
      setError(prev => ({
        ...prev,
        hotelDates:
          translations?.['b2b.txt.MSG026'] ||
          'Ngày trả phòng phải sau ngày nhận phòng',
      }));
      setFilter(prev => ({ ...prev, checkout }));
      return;
    }
    setError(prev => ({ ...prev, hotelDates: '' }));
    setFilter(prev => ({ ...prev, checkout }));
  };

  const comboTypeOptions = [
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET,
      label: translations?.['b2b.txt.comboFlightHotelSunWorld'],
    },
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_TICKET,
      label: translations?.['b2b.txt.comboFlightSunWorld'],
    },
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL,
      label: translations?.['b2b.txt.flightHotelBooking'],
    },
  ];

  const onChangeComboType = (comboType: ComboHolidayType) => {
    setError(prev => ({ ...prev, hotelDates: '' }));
    setFilter(prev => {
      const next = { ...prev, comboType };
      if (!isHotelCombo(comboType)) return next;
      if (
        next.departureDate &&
        next.returnDate &&
        moment(next.returnDate).isSame(moment(next.departureDate), 'day')
      ) {
        next.returnDate = moment(next.departureDate)
          .add(1, 'day')
          .format('YYYY-MM-DD');
      }
      const withHotelDates = syncHotelDates(next);
      return {
        ...withHotelDates,
        adult: clampAdultCount(
          withHotelDates.adult,
          comboType,
          withHotelDates.room,
          withHotelDates.child,
        ),
      };
    });
  };

  const onChangeComboTypeFromEvent = (e: {
    target: { value: ComboHolidayType };
  }) => {
    onChangeComboType(e.target.value);
  };

  // const passengerLimitMessage = translations?.['b2b.txt.MSG002'];

  // const syncPassengerError = (
  //   adult: number,
  //   child: number,
  //   passengerLimitError: boolean,
  // ) => {
  //   setError(err => ({
  //     ...err,
  //     passengers:
  //       passengerLimitError && isPassengerTotalExceeded(adult, child)
  //         ? passengerLimitMessage
  //         : !isPassengerTotalExceeded(adult, child)
  //         ? ''
  //         : err.passengers,
  //   }));
  // };

  // useEffect(() => {
  //   if (!isPassengerTotalExceeded(filter.adult, filter.child)) {
  //     setError(prev => (prev.passengers ? { ...prev, passengers: '' } : prev));
  //   }
  // }, [filter.adult, filter.child]);

  const handleChangeRoom = (value: number) => {
    setFilter(prev => {
      const { room, adult, child } = resolveRoomChangeState(
        value,
        prev.adult,
        prev.child,
      );
      return {
        ...prev,
        room,
        adult,
        child,
      };
    });
  };
  const handleChangeAdult = (value: number) => {
    setFilter(prev => {
      const adult = clampAdultCount(
        value,
        prev.comboType,
        prev.room,
        prev.child,
      );
      // syncPassengerError(adult, prev.child, false);
      return { ...prev, adult };
    });
  };
  const handleChangeChild = (value: number) => {
    setFilter(prev => {
      const child = clampChildCount(
        value,
        prev.adult,
        prev.comboType,
        prev.room,
      );
      // syncPassengerError(prev.adult, child, false);
      return { ...prev, child };
    });
  };
  const handleChangeInfant = value => {
    setFilter({ ...filter, infant: value });
  };
  const onClickSearch = () => {
    const searchFilter = {
      ...filter,
      ...(isHotelCombo(filter.comboType) && filter.checkin && filter.checkout
        ? {
            hotelNights: calculateHotelNights(filter.checkin, filter.checkout),
          }
        : {}),
    };
    const query = objectToSearchParams(searchFilter);
    history.replace(`/holiday?${query}`);
    filterSearchRef.current = searchFilter;
  };
  const onClickExtend = () => {
    setIsExtend(prev => !prev);
  };
  useEffect(() => {
    if (dataFlightSegment) {
      const arrivalCodeSet = new Set(
        dataFlightSegment.map(item => item.arrivalCode),
      );
      const dataRegionDestinationTemp = dataRegions?.map(region => ({
        ...region,
        airports: region.airports.filter(airport =>
          arrivalCodeSet.has(airport.code),
        ),
      }));
      setDataRegionsDestination(dataRegionDestinationTemp);
      setRegionDestinationSelected(dataRegionDestinationTemp[0]);
    }
  }, [dataFlightSegment]);

  const showHotelFields = isHotelCombo(filter.comboType);
  const adultMin = getAdultMinForCombo(filter.comboType, filter.room);
  const adultMax = getMaxAdultForCombo(
    filter.child,
    filter.comboType,
    filter.room,
  );
  const childMax = getMaxChildForCombo(
    filter.adult,
    filter.comboType,
    filter.room,
  );
  const isDisableMinusAdult = isAdultDecrementDisabled(
    filter.adult,
    filter.comboType,
    filter.room,
  );
  const hotelNights = calculateHotelNights(filter.checkin, filter.checkout);

  return (
    <FilterSearchWrapper>
      <div className="headerSearch">
        {airportSelected && (
          <div>
            <div className="titleSearch">
              {formatAirport(airportSelected)}{' '}
              {airportDestinationSelected && (
                <>
                  <i
                    className={`fa-solid ${
                      filter.stage === 'round-trip'
                        ? 'fa-arrow-right-arrow-left'
                        : 'fa-arrow-right'
                    }`}
                    style={{ fontSize: 12 }}
                  ></i>{' '}
                  {formatAirport(airportDestinationSelected)}{' '}
                </>
              )}
            </div>
            {filter.departureDate && (
              <div className="subTitleSearch">
                {formatDate(moment(filter.departureDate), translations)} -{' '}
                {+filter.adult + +filter.child + +filter.infant}{' '}
                {translations?.['b2b.txt.passengers']}
              </div>
            )}
          </div>
        )}
        <ButtonExtend onClick={onClickExtend}>
          {translations?.[isExtend ? 'b2c.txt.viewShort' : 'b2b.txt.extend']}
        </ButtonExtend>
      </div>
      {isExtend && (
        <>
          <BoxItemSearch isMobile={isMobile} height={'auto'}>
            <StyledSelect
              suffixIcon={<ArrowDownIcon />}
              value={filter.stage}
              onChange={onChangeFilterStage}
              options={dataStage}
              className="stageSelect"
            />
            <div
              className="comboTypeBar"
              role="radiogroup"
              style={{ width: isMobile ? '100%' : '100%' }}
            >
              {CustomRadioCatalog(
                comboTypeOptions,
                filter.comboType,
                onChangeComboTypeFromEvent,
                { fontSize: 13, lineHeight: 1.35 },
              )}
            </div>
          </BoxItemSearch>
          <BoxItemSearch
            height={
              isMobile || isTablet
                ? 'auto'
                : error.departureDate || error.returnDate
                ? '70px'
                : '50px'
            }
            isMobile={isMobile || isTablet}
          >
            {isMobile || isTablet ? (
              <BoxItemSearch style={{ width: '100%' }}>
                <>
                  <AirportSelectPopover
                    type="departure"
                    isOpen={isOpenDeparturePoint}
                    onOpenChange={handleOpenChangeDeparturePoint}
                    textValue={textInputDeparture}
                    onTextChange={handleInputChange('departure')}
                    isSearching={isOnChangeDeparture}
                    regions={dataRegions}
                    selectedRegion={regionSelected}
                    selectedAirport={airportSelected}
                    excludedAirportCode={airportDestinationSelected?.code}
                    dataSearchAirports={dataSearchAirports}
                    onSelectRegion={region =>
                      onClickRegion(region, 'departure')
                    }
                    onSelectAirport={airport =>
                      onClickAirport(airport, 'departure')
                    }
                    popupContainerRef={popupContainer}
                    device={device}
                    windowWidth={windowSize.width}
                    placeholder={translations?.['b2b.txt.selectDeparturePoint']}
                    isDisabled={false}
                    isLoading={isLoadingMasterData}
                  />
                  <div className="boxColumnDivider">
                    <div className="boxTrailing" onClick={onSwapPoint}>
                      <TrailingIcon />
                    </div>
                  </div>
                  <AirportSelectPopover
                    type="destination"
                    isOpen={isOpenDestination}
                    onOpenChange={handleOpenChangeDestination}
                    textValue={textInputDestination}
                    onTextChange={handleInputChange('destination')}
                    isSearching={isOnChangeDestination}
                    regions={dataRegionsDestination}
                    selectedRegion={regionDestinationSelected}
                    selectedAirport={airportDestinationSelected}
                    excludedAirportCode={airportSelected?.code}
                    dataSearchAirports={dataSearchAirports}
                    onSelectRegion={region =>
                      onClickRegion(region, 'destination')
                    }
                    onSelectAirport={airport =>
                      onClickAirport(airport, 'destination')
                    }
                    popupContainerRef={popupDestinationContainer}
                    device={device}
                    windowWidth={windowSize.width}
                    placeholder={translations?.['b2b.txt.selectDestination']}
                    isDisabled={!textInputDeparture && !isLoadingFlightSegment}
                    isLoading={isLoadingFlightSegment}
                  />
                </>
              </BoxItemSearch>
            ) : (
              <>
                <AirportSelectPopover
                  type="departure"
                  isOpen={isOpenDeparturePoint}
                  onOpenChange={handleOpenChangeDeparturePoint}
                  textValue={textInputDeparture}
                  onTextChange={handleInputChange('departure')}
                  isSearching={isOnChangeDeparture}
                  regions={dataRegions}
                  selectedRegion={regionSelected}
                  selectedAirport={airportSelected}
                  excludedAirportCode={airportDestinationSelected?.code}
                  dataSearchAirports={dataSearchAirports}
                  onSelectRegion={region => onClickRegion(region, 'departure')}
                  onSelectAirport={airport =>
                    onClickAirport(airport, 'departure')
                  }
                  popupContainerRef={popupContainer}
                  device={device}
                  windowWidth={windowSize.width}
                  placeholder={translations?.['b2b.txt.selectDeparturePoint']}
                  isDisabled={false}
                  isLoading={isLoadingMasterData}
                />
                <div className="boxColumnDivider">
                  <div className="boxTrailing" onClick={onSwapPoint}>
                    <TrailingIcon />
                  </div>
                </div>
                <AirportSelectPopover
                  type="destination"
                  isOpen={isOpenDestination}
                  onOpenChange={handleOpenChangeDestination}
                  textValue={textInputDestination}
                  onTextChange={handleInputChange('destination')}
                  isSearching={isOnChangeDestination}
                  regions={dataRegionsDestination}
                  selectedRegion={regionDestinationSelected}
                  selectedAirport={airportDestinationSelected}
                  excludedAirportCode={airportSelected?.code}
                  dataSearchAirports={dataSearchAirports}
                  onSelectRegion={region =>
                    onClickRegion(region, 'destination')
                  }
                  onSelectAirport={airport =>
                    onClickAirport(airport, 'destination')
                  }
                  popupContainerRef={popupDestinationContainer}
                  device={device}
                  windowWidth={windowSize.width}
                  placeholder={translations?.['b2b.txt.selectDestination']}
                  isDisabled={!textInputDeparture && !isLoadingFlightSegment}
                  isLoading={isLoadingFlightSegment}
                />
              </>
            )}
            <div className="boxColumnDivider" />
            <div
              style={{
                display: 'flex',
                flex: 1,
                flexDirection: isMobile ? 'column' : 'row',
                width: '100%',
                height: 'auto',
              }}
            >
              <div className="boxDate">
                <CalendarIcon />
                <div style={{ width: '100%' }}>
                  <DatePickerWrapper>
                    <StyledDatePicker
                      className="dataPicker"
                      dropdownClassName="custom-date-popup"
                      getPopupContainer={trigger => trigger.parentElement!}
                      suffixIcon={<></>}
                      placeholder={
                        translations?.['b2b.txt.selectDepartureDate']
                      }
                      format={date => formatDate(date, translations)}
                      allowClear
                      disabledDate={current =>
                        current && current < moment().startOf('day')
                      }
                      value={
                        moment(filter.departureDate).isValid()
                          ? moment(filter.departureDate)
                          : null
                      }
                      onChange={onChangeDepartureDate}
                    />
                  </DatePickerWrapper>
                  {error.departureDate && (
                    <TextError>{error.departureDate}</TextError>
                  )}
                </div>
              </div>
              {filter.stage === 'round-trip' && (
                <>
                  <div
                    className="boxColumnDivider"
                    style={{ height: 'auto' }}
                  />
                  <div className="boxDate align-items-start flex-column gap-0">
                    <div className="boxDate px-0" style={{ width: '100%' }}>
                      <CalendarIcon />
                      <div style={{ width: '100%' }}>
                        <DatePickerWrapper>
                          <StyledDatePicker
                            className="dataPicker"
                            dropdownClassName="custom-date-popup"
                            getPopupContainer={trigger =>
                              trigger.parentElement!
                            }
                            suffixIcon={<></>}
                            placeholder={
                              translations?.['b2b.txt.selectReturnDate']
                            }
                            format={date => formatDate(date, translations)}
                            allowClear
                            disabledDate={current => {
                              if (!current) return false;
                              if (current < moment().startOf('day'))
                                return true;
                              if (filter.departureDate) {
                                const departure = moment(filter.departureDate);
                                if (departure.isValid()) {
                                  if (isHotelCombo(filter.comboType)) {
                                    return current.isSameOrBefore(
                                      departure.startOf('day'),
                                      'day',
                                    );
                                  }
                                  // return current < departure.startOf('day');
                                  return current.isBefore(
                                    departure.startOf('day'),
                                    'day',
                                  );
                                }
                              }
                              return false;
                            }}
                            value={
                              moment(filter.returnDate).isValid()
                                ? moment(filter.returnDate)
                                : null
                            }
                            onChange={onChangeReturnDate}
                          />
                        </DatePickerWrapper>
                      </div>
                    </div>
                    {error.returnDate && (
                      <TextError>{error.returnDate}</TextError>
                    )}
                  </div>
                </>
              )}
            </div>
          </BoxItemSearch>
          {showHotelFields && (
            <BoxItemSearch
              height={
                isMobile || isTablet
                  ? 'auto'
                  : error.hotelDates
                  ? '70px'
                  : '50px'
              }
              style={{
                alignItems: error.hotelDates ? 'flex-start' : 'center',
                flexWrap: device === 'desktop' ? 'nowrap' : 'wrap',
              }}
            >
              <div className="boxDate">
                <CalendarIcon />
                <div style={{ width: '100%' }}>
                  <DatePickerWrapper>
                    <StyledDatePicker
                      className="dataPicker"
                      dropdownClassName="custom-date-popup"
                      getPopupContainer={trigger => trigger.parentElement!}
                      suffixIcon={<></>}
                      placeholder={translations?.['b2b.txt.hotelCheckIn']}
                      format={date => formatDate(date, translations)}
                      allowClear
                      disabledDate={current =>
                        current ? hotelDisabledDate(current) : false
                      }
                      value={
                        moment(filter.checkin).isValid()
                          ? moment(filter.checkin)
                          : null
                      }
                      onChange={onChangeCheckInDate}
                    />
                  </DatePickerWrapper>
                </div>
              </div>
              <div
                className="boxColumnDivider"
                style={{ height: isTablet ? '50px' : '100%' }}
              />
              <div
                className="boxDate align-items-start flex-column gap-0"
                style={{ paddingLeft: isMobile || isTablet ? 0 : 14, flex: 1 }}
              >
                <div className="boxDate w-100">
                  <CalendarIcon />
                  <DatePickerWrapper>
                    <StyledDatePicker
                      className="dataPicker"
                      dropdownClassName="custom-date-popup"
                      getPopupContainer={trigger => trigger.parentElement!}
                      suffixIcon={<></>}
                      placeholder={translations?.['b2b.txt.hotelCheckOut']}
                      format={date => formatDate(date, translations)}
                      allowClear
                      disabledDate={current => {
                        if (!current) return false;
                        if (hotelDisabledDate(current)) return true;
                        if (filter.checkin) {
                          const checkIn = moment(filter.checkin);
                          if (
                            checkIn.isValid() &&
                            current.isSameOrBefore(checkIn, 'day')
                          ) {
                            return true;
                          }
                        }
                        return false;
                      }}
                      value={
                        moment(filter.checkout).isValid()
                          ? moment(filter.checkout)
                          : null
                      }
                      onChange={onChangeCheckOutDate}
                    />
                  </DatePickerWrapper>
                </div>
                {error.hotelDates && <TextError>{error.hotelDates}</TextError>}
              </div>
              {hotelNights > 0 && (
                <span
                  className="nightsBadge"
                  style={{
                    marginLeft: isMobile || isTablet ? 0 : 'auto',
                  }}
                >
                  {hotelNights} {translations?.['b2b.txt.nights']}
                </span>
              )}
              {isTablet && (
                <div
                  style={{
                    borderBottom: '1px solid #e5e5e5',
                    width: '100%',
                  }}
                />
              )}
              <div className="boxColumnDivider" />
              <div
                className="hotelRoomSection"
                style={{
                  paddingLeft: isMobile || isTablet ? 0 : 10,
                  width: isMobile || isTablet ? '100%' : 'auto',
                  paddingRight: isMobile || isTablet ? 16 : 10,
                }}
              >
                <div className="sub-title">
                  {translations?.['b2b.txt.roomQuantity']}
                </div>
                <div
                  className="form-inputNumber"
                  style={{
                    marginLeft: isMobile || isTablet ? 'auto' : 0,
                    marginBottom: isMobile || isTablet ? 10 : 0,
                    marginTop: isTablet ? 10 : 0,
                  }}
                >
                  <InputNumberContainer
                    value={filter.room}
                    onChange={value => handleChangeRoom(value)}
                    min={1}
                    max={5}
                    isDisableMinus={filter.room <= 1}
                    isRunChangeEventWithSameValue
                    isSyncValuePropAndCompValueWhenTextValueEmpty
                  />
                </div>
              </div>
            </BoxItemSearch>
          )}
          <BoxItemSearch
            style={{
              gap: device === 'desktop' ? 30 : 10,
              flexWrap: 'wrap',
              marginTop: device === 'desktop' ? 0 : 10,
              height: device === 'desktop' ? '50px' : 'auto',
              alignItems: device === 'desktop' ? 'center' : 'flex-start',
            }}
          >
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.adult']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.adultAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{
                  marginLeft: device === 'desktop' ? 0 : 'auto',
                  marginRight: device === 'desktop' ? 0 : 14,
                }}
              >
                <InputNumberContainer
                  value={filter.adult}
                  onChange={value => handleChangeAdult(value)}
                  min={adultMin}
                  max={adultMax}
                  isDisableMinus={isDisableMinusAdult}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.child']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.childAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{
                  marginLeft: device === 'desktop' ? 0 : 'auto',
                  marginRight: device === 'desktop' ? 0 : 14,
                }}
              >
                <InputNumberContainer
                  value={filter.child}
                  onChange={value => handleChangeChild(value)}
                  min={0}
                  max={childMax}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.infant']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.infantAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{
                  marginLeft: device === 'desktop' ? 0 : 'auto',
                  marginRight: device === 'desktop' ? 0 : 14,
                }}
              >
                <InputNumberContainer
                  value={filter.infant}
                  onChange={value => handleChangeInfant(value)}
                  min={0}
                  max={+filter.adult}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
            <ButtonSearch
              disabled={
                !filter.departure ||
                !filter.destination ||
                !filter.departureDate ||
                !textInputDeparture ||
                !textInputDestination ||
                isRefreshing ||
                hasError(error) ||
                (filter.stage === 'round-trip' && !filter.returnDate) ||
                (showHotelFields &&
                  (!filter.checkin || !filter.checkout || !!error.hotelDates))
              }
              onClick={onClickSearch}
              style={{
                width: device === 'desktop' ? 'auto' : '100%',
                marginRight: device === 'desktop' ? 0 : 14,
                borderBottomRightRadius: device === 'desktop' ? 10 : 0,
              }}
            >
              {translations?.['b2c.txt.search']}
            </ButtonSearch>
          </BoxItemSearch>
          {/* {error.passengers && (
            <PassengerErrorBar>
              <TextError>{error.passengers}</TextError>
            </PassengerErrorBar>
          )} */}
        </>
      )}
    </FilterSearchWrapper>
  );
};
export default FilterSearch;
const BoxItemSearch = styled.div<{ height?: string; isMobile?: boolean }>`
  height: ${props => props.height ?? '50px'};
  border-bottom: 1px solid #e5e5e5;
  padding-left: 14px;
  display: flex;
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  align-items: ${props => (props.isMobile ? 'flex-start' : 'center')};
`;
const TextError = styled.div`
  font-size: 12px;
  color: red;
  line-height: 1.4;
`;
const PassengerErrorBar = styled.div`
  padding: 4px 14px 10px;
  border-bottom: 1px solid #e5e5e5;
  background: #fff;
`;
const ButtonSearch = styled.button`
  height: 50px;
  background: var(--color-gradient);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-bottom-right-radius: 10px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #e5e5e5;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    background: #d4d4d4;
    color: #444444;
    cursor: not-allowed;
    opacity: 1;
  }
  margin-left: auto;
`;
const ButtonExtend = styled.button`
  background: var(--color-gradient);
  border-radius: 5px;
  color: #fff;
  border: none;
  padding: 10px 20px;
  min-width: fit-content;
  font-size: 14px;
  &:hover {
    opacity: 0.8;
  }
  height: 50px;
`;
